import React from 'react'
import { Modal, Button, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import {useSelector} from "react-redux";

const FormModal = ({ show, handleClose }) => {
    const selectedForm = useSelector(state => state.selectedForm)
    const {form_name, description, form_status, form_associated_project} = selectedForm;

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                View Form
            </ModalHeader>  
            <ModalBody>
                <h3 className="fw-bolder mb-6">{form_name}</h3>
                <div className="flex flex-col gap-4">
                    <UserProperty property="Description" value={description} />
                    <UserProperty property="Status" value={form_status} />
                    <UserProperty property="Associated project" value={form_associated_project} />
                    {/* <UserProperty property="Password" value={password} />
                    <UserProperty property="User type" value={user_type} />
                    <UserProperty property="User status" value={user_status} />
                    <UserProperty property="Username"value={username} /> */}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="light" onClick={handleClose}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
}

const UserProperty = ({ property, value }) =>
    <InputGroup>
        <InputGroupAddon addonType="prepend">
            <InputGroupText>{property}</InputGroupText>
        </InputGroupAddon>
        <Input
            readOnly
            defaultValue={value}
        />
    </InputGroup>

export default FormModal
